
import store from "../store"
import {taskrunner} from "./taskrunner";
import {
    ResourceInvalidationTriggers
} from "@k/global/resourcemanager/resourceManager";
import {ResourceLoader, ResourceLoaderConstructorArguments} from "@k/global/resourcemanager/resourceLoader";
import {ResourceManagerTask} from "@k/global/resourcemanager/task";
import {Resource, ResourceConstructorArguments} from "@k/global/resourcemanager/resource";
import {EventVerteiler} from "@k/global/eventVerteiler";
import {Produktresponse} from "@k/js/databaseInterfaceClasses"
import {IResourceManager} from "@k/global/resourcemanager/IResourceManager";
import {logIfDebug} from "@k/global/logFunctions";

export const resourcemanagerVue :IResourceManager = {
    registerProduktPHPResource(data: Produktresponse, resourceNameSuffix="") {
        store.commit("registerResource", {resourceName:"produkt.php"+resourceNameSuffix, startingStati:["loaded"], data, invalidatedWhen: ResourceInvalidationTriggers.PRODUCTCHANGE})
    },
    getLoader(args: ResourceLoaderConstructorArguments) {
        return new ResourceLoader(args);
    },
    taskExists: (taskname)=>taskrunner.taskExists(taskname),
    checkTasksAndExecute:()=>taskrunner.checkTasksAndExecute(),
    createTask:(taskName: string)=>taskrunner.createTask(taskName),
    addOrExecuteTask: (task: ResourceManagerTask)=>taskrunner.addOrExecuteTask(task),

    resourceExists: (resourceName)=>store.getters.resourceExists(resourceName),
    appendStatus:(resourceName: string, newStatus: string)=>{
        store.commit("appendStatus", {resourceName, newStatus})
        store.dispatch("checkTasksAndExecute");
    },
    getResourceByName:(resourceName: string)=>store.getters.getResourceByName(resourceName),
    publishResource:(resourceName: string, response)=>store.commit("addDataToResource", {resourceName, data: response}),
    resourceHasState:(resourceName: string, state: string)=>store.getters.resourceHasState(resourceName, state),
    executeInvalidation(eventName: string) {
        store.dispatch("deleteInvalidatedResources", eventName);
        taskrunner.executeInvalidation(eventName);
    },

    getOrRegisterResource(resourceName: string) {
        const resource = store.getters.getResourceByName(resourceName);
        if (resource) {
            return resource;
        }
        const newResource = new Resource({resourceName: resourceName});
        store.commit("addResource", newResource);
        return newResource;
    },


    registerLoadedResourceWithoutData(resourceName, invalidationTrigger) {
        const r = new Resource({resourceName: resourceName, startingStati: ["loaded", "done"]});
        if (invalidationTrigger !== null) {
            r.invalidAfter(invalidationTrigger);
        }
        store.commit("addResource", r);
        resourcemanagerVue.checkTasksAndExecute();
    },

    registerResource(param: ResourceConstructorArguments): Resource {
        const resourceByName = store.getters.getResourceByName(param.resourceName);
        if (resourceByName) {
            logIfDebug("resource " + param.resourceName + " already registered");
            return resourceByName
        }
        const resource = new Resource(param);
        store.commit("addResource", resource);
        resourcemanagerVue.checkTasksAndExecute();
        return resource;
    },
    deleteResourceByName(resourceName: string) {
        store.commit("deleteResource", resourceName)
    }

}

ResourceManagerTask.setResourceManager(resourcemanagerVue);
Resource.setResourceManager(resourcemanagerVue);
ResourceLoader.setResourceManager(resourcemanagerVue);
EventVerteiler.setResourceManager(resourcemanagerVue);
